import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=1b052b94&scoped=true"
var script = {}
import style0 from "./footer.vue?vue&type=style&index=0&id=1b052b94&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b052b94",
  null
  
)

export default component.exports